import { connect } from 'react-redux'

import { getAccessToken } from '../../../selectors/auth'
import { getUserId } from '../../../selectors/user'
import { createComplaint } from '../actions/createComplaint'
import { trackIngredientsGetInTouchClick } from '../actions/getHelp'
import { loadRefundAmount } from '../actions/loadRefundAmount'
import { getCompensation, getIsMultiComplaints } from '../selectors/compensationSelectors'
import {
  getIsRefundOrComplaintPending,
  getIsRefundOrComplaintError,
  getSelectedIngredients,
} from '../selectors/selectors'
import { Refund } from './Refund'

const mapStateToProps = (state) => ({
  compensation: getCompensation(state),
  user: {
    id: getUserId(state),
    accessToken: getAccessToken(state),
  },
  isAnyPending: getIsRefundOrComplaintPending(state),
  isAnyError: getIsRefundOrComplaintError(state),
  isMultiComplaints: getIsMultiComplaints(state),
  numberOfIngredients: Object.keys(getSelectedIngredients(state)).length,
})

const RefundContainer = connect(mapStateToProps, {
  createComplaint,
  loadRefundAmount,
  trackIngredientsGetInTouchClick,
})(Refund)

export { RefundContainer }
